// =============================================================================
// CAPA DE DATOS (MOCK)
// -----------------------------------------------------------------------------
// Toda la data de la demo vive acá. Está pensada para reemplazarse después por
// llamadas a la base real de cada inmobiliaria SIN tocar la UI: alcanza con
// exponer las mismas funciones (getPropiedades, getContratos, etc.) desde una
// API y devolver objetos con la misma forma. Ver /app/docs/esquema-datos.md
// =============================================================================

import { addDays, startOfWeek } from "date-fns";

const HOY = new Date();
HOY.setHours(0, 0, 0, 0);

function iso(d) {
  return d.toISOString();
}
function masDias(n) {
  return iso(addDays(HOY, n));
}

// -------------------------- Pools de datos realistas -------------------------

export const BARRIOS = ["Palermo", "Caballito", "Villa Crespo", "Belgrano"];

export const AGENTES = [
  { id: "ag-1", nombre: "Martín Gómez", email: "martin@palermosur.com.ar", telefono: "+54 9 11 5123-4567", color: "#1E3A8A", metaVisitas: 12 },
  { id: "ag-2", nombre: "Lucía Fernández", email: "lucia@palermosur.com.ar", telefono: "+54 9 11 5987-6543", color: "#064E3B", metaVisitas: 10 },
  { id: "ag-3", nombre: "Diego Rossi", email: "diego@palermosur.com.ar", telefono: "+54 9 11 5222-1188", color: "#701A3B", metaVisitas: 14 },
];

const CALLES = {
  Palermo: ["Gurruchaga", "Honduras", "Costa Rica", "Thames", "Malabia", "Armenia", "Gorriti", "El Salvador"],
  Caballito: ["Av. Rivadavia", "Rojas", "Hidalgo", "Felipe Vallese", "Doblas", "Rosario", "Beauchef"],
  "Villa Crespo": ["Serrano", "Aguirre", "Vera", "Acevedo", "Padilla", "Loyola", "Camargo"],
  Belgrano: ["Cuba", "Arcos", "Juramento", "Echeverría", "Montañeses", "Amenábar", "Virrey del Pino"],
};

const NOMBRES = ["Sofía", "Mateo", "Valentina", "Benjamín", "Camila", "Joaquín", "Martina", "Tomás", "Catalina", "Lucas", "Julieta", "Nicolás", "Agustina", "Santiago", "Florencia", "Gonzalo", "Delfina", "Facundo", "Carla", "Ramiro", "Paula", "Ignacio", "Micaela", "Federico"];
const APELLIDOS = ["Giménez", "Álvarez", "Pérez", "Romero", "Sosa", "Torres", "Ruiz", "Díaz", "Acosta", "Benítez", "Molina", "Silva", "Cabrera", "Ferreyra", "Villalba", "Ibáñez", "Ledesma", "Juárez", "Luna", "Ocampo"];

const AMENITIES = ["Cochera", "Pileta", "SUM", "Parrilla", "Gimnasio", "Laundry", "Seguridad 24h", "Solárium", "Baulera"];
const TIPOS = ["Departamento", "PH", "Monoambiente", "Casa"];
const INDICES = ["ICL", "IPC", "Fijo"];
const IMAGENES = [
  "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80",
  "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&q=80",
  "https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800&q=80",
  "https://images.unsplash.com/photo-1484154218962-a197022b5858?w=800&q=80",
  "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80",
  "https://images.unsplash.com/photo-1493809842364-78817add7ffb?w=800&q=80",
  "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800&q=80",
  "https://images.unsplash.com/photo-1598928506311-c55ded91a20c?w=800&q=80",
];

// PRNG determinístico para que la demo sea estable entre recargas
let _seed = 42;
function rnd() {
  _seed = (_seed * 1103515245 + 12345) & 0x7fffffff;
  return _seed / 0x7fffffff;
}
function pick(arr) {
  return arr[Math.floor(rnd() * arr.length)];
}
function entre(min, max) {
  return Math.floor(rnd() * (max - min + 1)) + min;
}
function persona() {
  return `${pick(NOMBRES)} ${pick(APELLIDOS)}`;
}
function tel() {
  return `+54 9 11 ${entre(4000, 6999)}-${entre(1000, 9999)}`;
}

// ------------------------------- Propiedades --------------------------------

function generarPropiedades() {
  const props = [];
  for (let i = 0; i < 40; i++) {
    const barrio = pick(BARRIOS);
    const tipo = pick(TIPOS);
    const operacion = rnd() > 0.78 ? "Venta" : "Alquiler";
    const ambientes = tipo === "Monoambiente" ? 1 : entre(2, 5);
    const metros = tipo === "Monoambiente" ? entre(28, 42) : entre(45, 160);
    const antiguedad = entre(0, 45);
    const expensas = Math.round((metros * entre(1800, 3200)) / 1000) * 1000;
    const ocupado = operacion === "Alquiler" && rnd() > 0.45;
    const amenitiesSel = AMENITIES.filter(() => rnd() > 0.6);
    const precio =
      operacion === "Venta"
        ? entre(90000, 420000) * 1000 // en USD-equivalente mostrado como precio total
        : Math.round((metros * entre(5200, 8200)) / 1000) * 1000;
    props.push({
      id: `prop-${i + 1}`,
      titulo: `${tipo} ${ambientes} amb. en ${barrio}`,
      direccion: `${pick(CALLES[barrio])} ${entre(100, 3900)}`,
      barrio,
      tipo,
      operacion,
      ambientes,
      dormitorios: Math.max(1, ambientes - 1),
      banos: entre(1, ambientes > 3 ? 3 : 2),
      m2: metros,
      m2Cubiertos: Math.round(metros * 0.9),
      antiguedad,
      precio,
      moneda: operacion === "Venta" ? "USD" : "ARS",
      expensas,
      cochera: amenitiesSel.includes("Cochera"),
      mascotas: rnd() > 0.5,
      amenities: amenitiesSel,
      disponible: !ocupado || rnd() > 0.5,
      estadoOcupacion: ocupado ? "Ocupado" : "Libre",
      requisitos: "Garantía propietaria o seguro de caución. Recibo de sueldo o monotributo.",
      imagen: IMAGENES[i % IMAGENES.length],
      agenteId: AGENTES[i % 3].id,
      descripcion:
        "Luminoso, excelente distribución, muy bien ubicado a metros del subte y de locales gastronómicos. Apto crédito.",
    });
  }
  return props;
}

export const PROPIEDADES = generarPropiedades();

// -------------------------------- Contratos ---------------------------------

function generarContratos() {
  const contratos = [];
  const alquiler = PROPIEDADES.filter((p) => p.operacion === "Alquiler");
  for (let i = 0; i < 60; i++) {
    const prop = alquiler[i % alquiler.length];
    const indice = pick(INDICES);
    const periodicidad = indice === "ICL" ? pick([3, 4, 6]) : indice === "IPC" ? pick([3, 6]) : 12;
    const monto = prop.precio + entre(-40000, 60000);
    const diasAVencer = entre(-40, 330);
    const diasAAjustar = entre(-10, 120);
    const ajustePct = indice === "Fijo" ? entre(8, 12) : entre(14, 32);
    const estado = diasAVencer < 0 ? "Vencido" : diasAVencer < 60 ? "Por vencer" : "Vigente";
    contratos.push({
      id: `con-${i + 1}`,
      propiedadId: prop.id,
      direccion: prop.direccion,
      barrio: prop.barrio,
      inquilino: { nombre: persona(), email: "inquilino@mail.com", telefono: tel() },
      propietario: { nombre: persona(), email: "propietario@mail.com", telefono: tel() },
      montoMensual: monto,
      indice,
      ajustePct,
      periodicidadAjusteMeses: periodicidad,
      proximaActualizacion: masDias(diasAAjustar),
      proximoMontoEstimado: Math.round((monto * (1 + ajustePct / 100)) / 1000) * 1000,
      inicio: masDias(-entre(60, 700)),
      vencimiento: masDias(diasAVencer),
      estado,
      depositoMeses: 1,
      diaPago: `del 1 al ${pick([5, 10, 12])}`,
      agenteId: prop.agenteId,
    });
  }
  return contratos;
}

export const CONTRATOS = generarContratos();

// Situaciones de ejemplo: hay al menos un contrato en cada situación
const SITUACIONES = ["Recién firmado", "Al día", "Con atraso", "Ajuste este mes", "Arreglo en curso", "En salida", "Finalizado"];
CONTRATOS.slice(0, 7).forEach((c, i) => {
  c.situacion = SITUACIONES[i];
});
CONTRATOS[0].inicio = masDias(-6);
CONTRATOS[0].proximaActualizacion = masDias(85);
CONTRATOS[3].proximaActualizacion = masDias(8);
CONTRATOS[5].estado = "En salida";
CONTRATOS[6].estado = "Finalizado";
CONTRATOS[6].vencimiento = masDias(-20);

// ---------------------------- Cobros del mes --------------------------------

function generarCobros() {
  const lista = CONTRATOS.map((c, i) => {
    const r = rnd();
    const estado = r > 0.72 ? "Pendiente" : r > 0.6 ? "Atrasado" : "Pagado";
    const vence = estado === "Atrasado" ? masDias(-entre(1, 12)) : masDias(entre(0, 10));
    return {
      id: `cob-${i + 1}`,
      contratoId: c.id,
      inquilino: c.inquilino.nombre,
      direccion: c.direccion,
      periodo: "Mes en curso",
      monto: c.montoMensual,
      vencimiento: vence,
      estado,
      fechaPago: estado === "Pagado" ? masDias(-entre(1, 8)) : null,
      recordatorioWhatsApp: estado !== "Pagado",
    };
  });
  // Consistencia con las situaciones de ejemplo
  lista[0].estado = "Pendiente";
  lista[0].fechaPago = null;
  lista[1].estado = "Pagado";
  lista[1].fechaPago = masDias(-3);
  lista[2].estado = "Atrasado";
  lista[2].vencimiento = masDias(-6);
  lista[2].fechaPago = null;
  return lista;
}

export const COBROS = generarCobros();

// ----------------------- Reclamos y mantenimiento ---------------------------

const CATEGORIAS_RECLAMO = ["Plomería", "Electricidad", "Climatización", "Cerrajería", "Humedad", "Ascensor"];
const TITULOS_RECLAMO = {
  Plomería: "Pérdida de agua en cocina",
  Electricidad: "Tablero que salta",
  Climatización: "Aire acondicionado no enfría",
  Cerrajería: "Cerradura de puerta de entrada trabada",
  Humedad: "Mancha de humedad en techo del dormitorio",
  Ascensor: "Ascensor fuera de servicio",
};
const ESTADOS_RECLAMO = ["Abierto", "Asignado", "En curso", "Cerrado"];

function generarReclamos() {
  const reclamos = [];
  for (let i = 0; i < 14; i++) {
    const c = CONTRATOS[entre(0, CONTRATOS.length - 1)];
    const cat = pick(CATEGORIAS_RECLAMO);
    const estado = pick(ESTADOS_RECLAMO);
    reclamos.push({
      id: `rec-${i + 1}`,
      contratoId: c.id,
      direccion: c.direccion,
      inquilino: c.inquilino.nombre,
      categoria: cat,
      titulo: TITULOS_RECLAMO[cat],
      descripcion: "El inquilino reportó el problema por el portal. Se solicita visita técnica a la brevedad.",
      prioridad: pick(["Alta", "Media", "Baja"]),
      estado,
      asignadoA: estado === "Abierto" ? null : pick(["Plomero Juan", "Electricista Ramón", "Service Clima SA", AGENTES[i % 3].nombre]),
      fechaReporte: masDias(-entre(1, 20)),
      fechaCierre: estado === "Cerrado" ? masDias(-entre(0, 3)) : null,
    });
  }
  return reclamos;
}

export const RECLAMOS = generarReclamos();

// ------------------------- Asistente 24/7 (chats) ---------------------------

function generarConversaciones() {
  const base = [
    { q: "precio", a: "El alquiler es de {precio} por mes más {expensas} de expensas." },
    { q: "mascotas", a: "Sí, en esta propiedad se admiten mascotas." },
    { q: "visita", a: "Con gusto coordinamos una visita. ¿Te queda cómodo mañana a la tarde?" },
    { q: "requisitos", a: "Pedimos garantía propietaria o seguro de caución y comprobante de ingresos." },
    { q: "disponibilidad", a: "La unidad está disponible para mudarse a partir de este mes." },
  ];
  const convs = [];
  for (let i = 0; i < 20; i++) {
    const prop = PROPIEDADES[entre(0, PROPIEDADES.length - 1)];
    const fuera = rnd() > 0.45;
    const hh = fuera ? entre(19, 23) : entre(10, 17);
    const tomada = fuera && rnd() > 0.6;
    const tema = pick(base);
    const nombre = persona();
    const mensajes = [
      { de: "cliente", texto: `Hola, vi el aviso de ${prop.titulo}. ¿Me pasás info?`, hora: `${hh}:0${entre(1, 9)}` },
      {
        de: "bot",
        texto: `¡Hola ${nombre.split(" ")[0]}! Te paso la ficha de ${prop.direccion}, ${prop.barrio}. Alquiler ${"$ " + prop.precio.toLocaleString("es-AR")} + expensas. ¿Qué querés saber?`,
        hora: `${hh}:0${entre(1, 9)}`,
      },
      { de: "cliente", texto: `Quería saber sobre ${tema.q}.`, hora: `${hh}:1${entre(0, 9)}` },
      {
        de: "bot",
        texto: tema.a.replace("{precio}", "$ " + prop.precio.toLocaleString("es-AR")).replace("{expensas}", "$ " + prop.expensas.toLocaleString("es-AR")),
        hora: `${hh}:1${entre(0, 9)}`,
      },
    ];
    convs.push({
      id: `chat-${i + 1}`,
      canal: rnd() > 0.35 ? "WhatsApp" : "Web",
      contacto: { nombre, telefono: tel() },
      propiedadId: prop.id,
      propiedadTitulo: prop.titulo,
      direccion: prop.direccion,
      fueraDeHorario: fuera,
      tomada,
      agenteId: tomada ? AGENTES[i % 3].id : null,
      estado: tomada ? "Tomada por agente" : "Respondida por asistente",
      ultimaActividad: masDias(-entre(0, 4)),
      horaActividad: `${hh}:${entre(10, 59)}`,
      mensajes,
      ofrecioVisita: tema.q === "visita" || rnd() > 0.5,
    });
  }
  return convs;
}

export const CONVERSACIONES = generarConversaciones();

// ----------------------- Coordinación de visitas ----------------------------

function generarVisitas() {
  const estados = ["Propuesta", "Confirmada", "Reprogramada", "Realizada"];
  const visitas = [];
  const inicio = startOfWeek(HOY, { weekStartsOn: 1 });
  for (let i = 0; i < 16; i++) {
    const prop = PROPIEDADES[entre(0, PROPIEDADES.length - 1)];
    const ocupado = prop.estadoOcupacion === "Ocupado";
    const estado = ocupado ? pick(estados) : pick(["Confirmada", "Realizada", "Propuesta"]);
    const dia = entre(0, 6);
    const fecha = addDays(inicio, dia);
    const h = entre(10, 19);
    const franjas = ocupado
      ? [
          { dia: "Mar", rango: "18:00 - 19:00", elegida: estado !== "Propuesta" },
          { dia: "Jue", rango: "19:00 - 20:00", elegida: false },
          { dia: "Sáb", rango: "11:00 - 12:00", elegida: false },
        ]
      : [];
    visitas.push({
      id: `vis-${i + 1}`,
      propiedadId: prop.id,
      propiedadTitulo: prop.titulo,
      direccion: prop.direccion,
      barrio: prop.barrio,
      interesado: { nombre: persona(), telefono: tel() },
      agenteId: prop.agenteId,
      tipo: ocupado ? "Depto ocupado" : "Depto libre",
      estado,
      fecha: iso(fecha),
      hora: `${h}:00`,
      franjasPropuestas: franjas,
      confirmaciones: {
        interesado: estado !== "Propuesta",
        inquilino: ocupado ? estado === "Confirmada" || estado === "Realizada" : true,
        agente: estado === "Confirmada" || estado === "Realizada",
      },
      recordatorioEnviado: estado === "Confirmada",
    });
  }
  return visitas;
}

export const VISITAS = generarVisitas();

// ------------------------------ Interesados ---------------------------------

function generarInteresados() {
  const estados = ["Nuevo", "Contactado", "Visita agendada", "En negociación", "Cerrado"];
  const pasos = ["Enviar ficha completa", "Coordinar visita", "Confirmar documentación", "Presentar oferta", "Firmar reserva"];
  const leads = [];
  for (let i = 0; i < 22; i++) {
    const prop = PROPIEDADES[entre(0, PROPIEDADES.length - 1)];
    leads.push({
      id: `lead-${i + 1}`,
      nombre: persona(),
      telefono: tel(),
      email: "interesado@mail.com",
      propiedadId: prop.id,
      propiedadTitulo: prop.titulo,
      origen: pick(["WhatsApp", "Portal web", "Zonaprop", "Referido", "Cartel"]),
      estado: pick(estados),
      ultimaInteraccion: masDias(-entre(0, 15)),
      proximoPaso: pick(pasos),
      agenteId: prop.agenteId,
      historial: [
        { fecha: masDias(-entre(10, 15)), evento: "Primera consulta por el aviso" },
        { fecha: masDias(-entre(3, 9)), evento: "Se respondió con la ficha de la propiedad" },
        { fecha: masDias(-entre(0, 2)), evento: "Se ofreció coordinar visita" },
      ],
    });
  }
  return leads;
}

export const INTERESADOS = generarInteresados();

// ------------------------- Agenda semanal (eventos) -------------------------

function generarAgenda() {
  const inicio = startOfWeek(HOY, { weekStartsOn: 1 });
  const tipos = [
    { tipo: "Visita", color: "#1E3A8A" },
    { tipo: "Firma", color: "#064E3B" },
    { tipo: "Vencimiento", color: "#991B1B" },
    { tipo: "Tarea", color: "#854D0E" },
  ];
  const eventos = [];
  for (let i = 0; i < 24; i++) {
    const t = tipos[i % tipos.length];
    const dia = entre(0, 6);
    const h = entre(9, 18);
    const prop = PROPIEDADES[entre(0, PROPIEDADES.length - 1)];
    const ag = AGENTES[i % 3];
    const titulos = {
      Visita: `Visita · ${prop.direccion}`,
      Firma: `Firma contrato · ${prop.direccion}`,
      Vencimiento: `Vence contrato · ${prop.direccion}`,
      Tarea: pick(["Llamar a propietario", "Cargar aviso nuevo", "Relevar unidad", "Enviar liquidación"]),
    };
    eventos.push({
      id: `ev-${i + 1}`,
      tipo: t.tipo,
      color: t.color,
      titulo: titulos[t.tipo],
      diaSemana: dia, // 0 = lunes
      hora: h,
      fecha: iso(addDays(inicio, dia)),
      agenteId: ag.id,
      agenteNombre: ag.nombre,
    });
  }
  return eventos;
}

export const AGENDA = generarAgenda();

// ------------------------------ Liquidaciones -------------------------------

export function liquidacionesDePropietario(propietarioNombre) {
  const sus = CONTRATOS.filter((c) => c.propietario.nombre === propietarioNombre);
  return sus.map((c, i) => {
    const comision = Math.round(c.montoMensual * 0.07);
    const gastos = [
      { concepto: "Honorarios administración (7%)", monto: -comision },
      { concepto: "Gastos bancarios", monto: -2500 },
    ];
    const neto = c.montoMensual + gastos.reduce((s, g) => s + g.monto, 0);
    return {
      id: `liq-${c.id}`,
      contratoId: c.id,
      propietario: c.propietario.nombre,
      inquilino: c.inquilino.nombre,
      direccion: c.direccion,
      periodo: "Mes en curso",
      montoAlquiler: c.montoMensual,
      gastos,
      neto,
    };
  });
}

// --------------------------------- Helpers ----------------------------------

export function propiedadPorId(id) {
  return PROPIEDADES.find((p) => p.id === id);
}
export function agentePorId(id) {
  return AGENTES.find((a) => a.id === id);
}

// KPIs del Panel del Dueño
export function kpisHome() {
  const fueraDeHorario = CONVERSACIONES.filter((c) => c.fueraDeHorario).length;
  const visitasSemana = VISITAS.length;
  const pendientes = COBROS.filter((c) => c.estado === "Pendiente");
  const atrasados = COBROS.filter((c) => c.estado === "Atrasado");
  const reclamosAbiertos = RECLAMOS.filter((r) => r.estado !== "Cerrado").length;
  const porVencer = CONTRATOS.filter((c) => c.estado === "Por vencer" || c.estado === "Vencido").length;
  const porAjustar = CONTRATOS.filter((c) => {
    const d = (new Date(c.proximaActualizacion) - HOY) / 86400000;
    return d >= 0 && d <= 30;
  }).length;
  return {
    fueraDeHorario,
    visitasSemana,
    cobrosPendientes: pendientes.length,
    cobrosAtrasados: atrasados.length,
    montoPendiente: pendientes.reduce((s, c) => s + c.monto, 0),
    montoAtrasado: atrasados.reduce((s, c) => s + c.monto, 0),
    reclamosAbiertos,
    porVencer,
    porAjustar,
  };
}
